import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow",
  "use": "arrow-usage",
  "viewBox": "0 0 22 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 12\" id=\"arrow\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M16.058.9a.8.8 0 011.131 0l4.243 4.243a.8.8 0 010 1.131l-4.242 4.243a.8.8 0 11-1.132-1.131l2.877-2.877H.867a.8.8 0 010-1.6h18.068l-2.877-2.877a.8.8 0 010-1.132z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol